// extracted by mini-css-extract-plugin
module.exports = {"container":"c0rmkZ0","body":"yXzsT8","anchor":"zgzjEL","onlyMobile":"mkaZU5","onlyDesktop":"v5nnOB","topBreadCrumbs":"BGNvLC","bottomBreadcrumbs":"e1zS6G"};